import { render } from "./ModalNav.vue?vue&type=template&id=298f6e94&scoped=true"
import script from "./ModalNav.vue?vue&type=script&lang=js"
export * from "./ModalNav.vue?vue&type=script&lang=js"

import "./ModalNav.vue?vue&type=style&index=0&id=298f6e94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298f6e94"]])

export default __exports__